export default __webpack_public_path__ + "static/media/rain.9397f03e.png";